import { actionLabel, t } from '@rudy/shared/copy';

export { actionLabel, t };

const num = new Intl.NumberFormat('en-US');
export const fmtNum = (n: number) => num.format(n);

/** Chance as a percent with sensible precision: 0.84 %, 12.3 %, 100 %. */
export function fmtPct(pct: number): string {
  if (pct <= 0) return '0%';
  if (pct < 10) return `${pct.toFixed(2)}%`;
  if (pct < 100) return `${pct.toFixed(1)}%`;
  return '100%';
}

const dayFmt = new Intl.DateTimeFormat('en-GB', { day: 'numeric', month: 'short' });
const timeFmt = new Intl.DateTimeFormat('en-GB', { hour: '2-digit', minute: '2-digit' });
export const fmtDay = (iso: string) => dayFmt.format(new Date(iso));
export const fmtTime = (iso: string) => timeFmt.format(new Date(iso));
